import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
import { useIsTransportUser } from 'hooks/useCheckPermission';
// routes
import { PATH_PAGE } from '../routes/paths';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const isTransportUser = useIsTransportUser();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated && !isTransportUser) {
    return <Navigate to={PATH_PAGE.dashboard} />;
  }

  return <>{children}</>;
}
